import React, {useEffect} from "react";
import {useSetState} from "ahooks";
import {SDrawerOrModal} from "shj-components";
import {Checkbox, ConfigProvider, message} from "antd";

import {getEnums} from "@/services/homeService.ts";
import AddNewPlanModal from "@/components/AddNewPlanModal";
import {SeatAddClueModal} from "@/pages/salesWorkbench/workbenchList/components/SeatAddClueModal";
import {staffTypeMap} from "@/pages/salesWorkbench/workbenchList/dialog/addModal/typeEnums.tsx";
import styles from './index.module.less'
import {ChannelAddClueModal} from "@/pages/salesWorkbench/workbenchList/components/ChannelAddClueModal";

export default function AddModal(props) {
  const {
    open = false,
    onClose = () => {},
    reload = () => {},
  } = props;

  const [state, setState] = useSetState({
    checkedKey: 'SALES_TEMPLATE',
    clueTemplateEnum: [],
    modalOpen: false,
    loading: false,
  })

  useEffect(() => {
    if (open) {
      setState({ checkedKey: 'SALES_TEMPLATE' })
    }
  }, [open]);

  const onOk = () => {
    if (!state.checkedKey) {
      return message.error('请选择录入角色');
    }
    setState({modalOpen: true})
    onClose()
  }

  const getAddModal = () => {
    switch (state.modalOpen && state.checkedKey) {
      case 'CALL_PAGE':
        return <SeatAddClueModal
            reload={reload} open={state.modalOpen}
            onClose={() => setState({modalOpen: false})}/>;
      case 'CHANNEL_CLUE_ADD':
        return <ChannelAddClueModal
            open={state.modalOpen}
            onClose={() => {
              setState({modalOpen: false})
            }}
            reload={reload}
        />;
      default:
        return <AddNewPlanModal
            reload={reload} open={state.modalOpen}
            onClose={() => setState({modalOpen: false})}/>;
    }
  }

  return (<>
        <SDrawerOrModal
            open={open}
            mode={'modal'}
            title={'选择录入角色'}
            width={740}
            onCancel={onClose}
            okText={'确定'}
            onOk={onOk}
            loading={state.loading}
        >
          <ConfigProvider
              theme={{
                token: {
                  borderRadiusSM: 10,
                  controlInteractiveSize: 20,
                },
              }}
          >
            <Checkbox.Group value={[state.checkedKey]}
                            onChange={(value) => {
                              const current = value[value.length - 1]
                              current && setState({checkedKey: current})
                            }}
            >
              <div className={styles.boxWrap}>
                {Object.keys(staffTypeMap)?.map(key => <div key={key} className={styles.checkboxItem}
                                                          style={{
                                                            backgroundImage: `url(${staffTypeMap[key]?.img})`,
                                                            backgroundColor: `${staffTypeMap[key]?.bgColor}`,
                                                          }}>
                  <Checkbox value={key} name={'role'}>{staffTypeMap[key].title}</Checkbox>
                </div>)}
              </div>
            </Checkbox.Group>
          </ConfigProvider>
        </SDrawerOrModal>
        {getAddModal()}
      </>
  )
}